var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-container" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [
              _c("b-card-title", [
                _vm._v(" Product Sales Analysis Over Time "),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mb-3" },
            [
              _c(
                "b-col",
                [
                  _c("label", { attrs: { for: "productFilter" } }, [
                    _vm._v("Select Products (max 5):"),
                  ]),
                  _c("b-form-select", {
                    attrs: {
                      id: "productFilter",
                      options: _vm.productOptions,
                      multiple: "",
                      "select-size": 4,
                    },
                    on: { change: _vm.updateChart },
                    model: {
                      value: _vm.selectedProducts,
                      callback: function ($$v) {
                        _vm.selectedProducts = $$v
                      },
                      expression: "selectedProducts",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("apexcharts", {
            attrs: {
              type: "line",
              height: "500",
              options: _vm.chartOptions,
              series: _vm.chartSeries,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }